import React, { useState } from 'react';
import { CaretRight } from '@gbm-tech/icons';
import clsx from 'clsx';

import { SidebarSubModule } from '../../../dtos';
import { PageItemCollapsed } from '../PageItemCollapsed';

import { SubPagesContainer } from '../SubItem/styles';

import { Container } from './styles';

export type SubItemCollapsedProps = {
  subItem: SidebarSubModule;
};

export const SubItemCollapsed: React.FC<SubItemCollapsedProps> = ({
  subItem,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Container onClick={() => setIsOpen(!isOpen)}>
        <span>{subItem.name}</span>

        <div className={clsx('subItemCaretIcon', { 'is-open': isOpen })}>
          <CaretRight />
        </div>
      </Container>

      <SubPagesContainer visible={isOpen}>
        {subItem.pages.map((page) => (
          <PageItemCollapsed key={`subPageCollapsed ${page.id}`} page={page} />
        ))}
      </SubPagesContainer>
    </>
  );
};
